/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { Model49 } from '../model/model49';
import { Model50 } from '../model/model50';
import { Model9 } from '../model/model9';
import { PrivacyPolicySections } from '../model/privacyPolicySections';
import { PrivacyPolicySectionsCreateInput } from '../model/privacyPolicySectionsCreateInput';
import { PrivacyPolicySectionsList } from '../model/privacyPolicySectionsList';
import { PrivacyPolicySectionsUpdateInput } from '../model/privacyPolicySectionsUpdateInput';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PrivacyPolicySectionsService {

    protected basePath = 'http://localhost:5001';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete a PrivacyPolicySections
     * 
     * @param orgName 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling deleteOrgsOrgnamePrivacypolicysectionsId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteOrgsOrgnamePrivacypolicysectionsId.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all PrivacyPolicySections(s)
     * 
     * @param orgName 
     * @param populate 
     * @param archived 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param offset 
     * @param page 
     * @param limit 
     * @param sortBy 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnamePrivacypolicysections(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'body', reportProgress?: boolean): Observable<PrivacyPolicySectionsList>;
    public getOrgsOrgnamePrivacypolicysections(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivacyPolicySectionsList>>;
    public getOrgsOrgnamePrivacypolicysections(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivacyPolicySectionsList>>;
    public getOrgsOrgnamePrivacypolicysections(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnamePrivacypolicysections.');
        }










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (archived !== undefined && archived !== null) {
            queryParameters = queryParameters.set('archived', <any>archived);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('sortBy', <any>sortBy);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PrivacyPolicySectionsList>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the count of all PrivacyPolicySections(s)
     * 
     * @param orgName 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnamePrivacypolicysectionsCount(orgName: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<Model9>;
    public getOrgsOrgnamePrivacypolicysectionsCount(orgName: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model9>>;
    public getOrgsOrgnamePrivacypolicysectionsCount(orgName: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model9>>;
    public getOrgsOrgnamePrivacypolicysectionsCount(orgName: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnamePrivacypolicysectionsCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Model9>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get PrivacyPolicySections
     * 
     * @param orgName 
     * @param id 
     * @param populate 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<PrivacyPolicySections>;
    public getOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivacyPolicySections>>;
    public getOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivacyPolicySections>>;
    public getOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnamePrivacypolicysectionsId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnamePrivacypolicysectionsId.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PrivacyPolicySections>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get PrivacyPolicySections field
     * 
     * @param orgName 
     * @param id 
     * @param fieldName 
     * @param populate 
     * @param q 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnamePrivacypolicysectionsIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getOrgsOrgnamePrivacypolicysectionsIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getOrgsOrgnamePrivacypolicysectionsIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getOrgsOrgnamePrivacypolicysectionsIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnamePrivacypolicysectionsIdFieldname.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnamePrivacypolicysectionsIdFieldname.');
        }

        if (fieldName === null || fieldName === undefined) {
            throw new Error('Required parameter fieldName was null or undefined when calling getOrgsOrgnamePrivacypolicysectionsIdFieldname.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any>q);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections/${encodeURIComponent(String(id))}/${encodeURIComponent(String(fieldName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a PrivacyPolicySections
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnamePrivacypolicysections(orgName: string, body?: PrivacyPolicySectionsCreateInput, observe?: 'body', reportProgress?: boolean): Observable<PrivacyPolicySections>;
    public postOrgsOrgnamePrivacypolicysections(orgName: string, body?: PrivacyPolicySectionsCreateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivacyPolicySections>>;
    public postOrgsOrgnamePrivacypolicysections(orgName: string, body?: PrivacyPolicySectionsCreateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivacyPolicySections>>;
    public postOrgsOrgnamePrivacypolicysections(orgName: string, body?: PrivacyPolicySectionsCreateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnamePrivacypolicysections.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PrivacyPolicySections>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Import multiple PrivacyPolicySections
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnamePrivacypolicysectionsImport(orgName: string, body?: Model49, observe?: 'body', reportProgress?: boolean): Observable<Model50>;
    public postOrgsOrgnamePrivacypolicysectionsImport(orgName: string, body?: Model49, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model50>>;
    public postOrgsOrgnamePrivacypolicysectionsImport(orgName: string, body?: Model49, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model50>>;
    public postOrgsOrgnamePrivacypolicysectionsImport(orgName: string, body?: Model49, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnamePrivacypolicysectionsImport.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Model50>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections/import`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a PrivacyPolicySections
     * 
     * @param orgName 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, body?: PrivacyPolicySectionsUpdateInput, observe?: 'body', reportProgress?: boolean): Observable<PrivacyPolicySections>;
    public putOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, body?: PrivacyPolicySectionsUpdateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivacyPolicySections>>;
    public putOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, body?: PrivacyPolicySectionsUpdateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivacyPolicySections>>;
    public putOrgsOrgnamePrivacypolicysectionsId(orgName: string, id: string, body?: PrivacyPolicySectionsUpdateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnamePrivacypolicysectionsId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnamePrivacypolicysectionsId.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<PrivacyPolicySections>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections/${encodeURIComponent(String(id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Publish a PrivacyPolicySections
     * 
     * @param orgName 
     * @param id 
     * @param published 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnamePrivacypolicysectionsIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'body', reportProgress?: boolean): Observable<PrivacyPolicySections>;
    public putOrgsOrgnamePrivacypolicysectionsIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivacyPolicySections>>;
    public putOrgsOrgnamePrivacypolicysectionsIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivacyPolicySections>>;
    public putOrgsOrgnamePrivacypolicysectionsIdPublishedPublished(orgName: string, id: string, published: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnamePrivacypolicysectionsIdPublishedPublished.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnamePrivacypolicysectionsIdPublishedPublished.');
        }

        if (published === null || published === undefined) {
            throw new Error('Required parameter published was null or undefined when calling putOrgsOrgnamePrivacypolicysectionsIdPublishedPublished.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<PrivacyPolicySections>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/PrivacyPolicySections/${encodeURIComponent(String(id))}/published/${encodeURIComponent(String(published))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
